import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import store from '../../../redux/store';
import NotFound from '../../NotFound';
import FirstScreenExam from '../ExamDetails';
import FileUpload from './FileUpload';

export default function StartWrittenExam(props) {
  const dispatch = useDispatch()
  const location = useLocation()
  const [ExamData, setAllExamList] = React.useState({});
  const [ExamFetch, setExamFetch] = React.useState(false);
  const [NotFoundData, setNotFound] = React.useState(false)
  const [reload, setReload] = React.useState(false)
  const [choose, setChoose] = React.useState(0)
  const [AnswerArray, setAnswerArray] = React.useState([]);
  const [ResultData, setResultData] = React.useState({ id: 0, meta: { return_pdf: "" } });
  const [ResultDataDone, setResultDataDone] = React.useState(false);

  const fetchExam = (slug) => {
    setExamFetch(false)
    setReload(true)
    setNotFound(false)
    const id = store.getState().LoginState.id
    AdsGETApi({ slug: slug }, slugs.db_slug_written_exam)
      .then((res) => {
        if (res.data.length == 1) {
          setAllExamList(res.data[0])
          // })
          // .finally(() => {
          // setReload(false)
          fetchResult(res.data[0].id)
          // })
        }
        else {
          setNotFound(true)
          // setReload(false)
        }
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
      })

  }
  const [finishStatus, setfinishStatus] = React.useState(false);

  useEffect(() => {
    console.log("asdsahgdh")
    fetchExam(location.pathname.slice(slugs.start_written_exam.length + 1))
  }, [])
  const LoginState = useSelector((state) => state.LoginState);

  const fetchResult = (exam_id) => {
    setExamFetch(false)
    setReload(true)
    setNotFound(false)
    const id = store.getState().LoginState.id
    AdsGETApi({
      // slug: slug
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": `${LoginState.userID}`,
      "filter[meta_query][1][compare]": "=",
      "filter[meta_query][2][key]": "exam_id",
      "filter[meta_query][2][value][0]": `${exam_id}`,
      "filter[meta_query][2][compare]": "=",
    }, slugs.db_slug_written_exam_results)
      .then((res) => {
        if (res.data.length !== 0) {
          setResultData(res.data[0])
        }
        setReload(false)
        setExamFetch(true)
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
      })

  }



  return (
    <div style={{ backgroundColor: "#eee", minHeight: "90vh" }}>
      <div>
        <div className="row">
          <div className="form-view m-3">
            {ExamFetch &&
              <>
                {NotFoundData ?
                  <NotFound /> :
                  <>
                    <ViewExam ExamData={ExamData} ResultData={ResultData} />
                  </>
                }
              </>
            }
          </div>
        </div>
      </div>
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}


const ViewExam = ({ ExamData, ResultData }) => {
  const [ShowQuestion, setShowQuestion] = React.useState(false)
  const [ShowAnswer, setShowAnswer] = React.useState(false)
  const [ShowReturnAnswer, setShowReturnAnswer] = React.useState(false)
  const [AnswerPDF, setAnswerPDF] = React.useState("")

  return (
    <div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mt-3">
          <div className="row" style={{ margin: "10px" }}>
            <div className='col-sm-8'>
              <h2>{ExamData.title.rendered}</h2>
              <div>{ExamData.meta.instructions}</div>
              <div>Deadline: {ExamData.meta.deadline}</div>
              <div>Full Marks: {ExamData.meta.full_marks}</div>
            </div>
            <div className='col-sm-4'>
              <img src={ExamData.meta.featured_image} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mt-3">
          <div className="row" style={{ margin: "10px" }}>
            <h3>Question: </h3>
            {(ExamData.meta.image !== "" || ExamData.meta.pdf !== "") &&
              <div>
                <button className="sign-in-button-4"
                  onClick={() => {
                    setShowQuestion(true)
                  }}
                >
                  View Question
                </button>
              </div>
            }

            {ResultData.id == 0 ?
              <div style={{ margin: "10px 0" }}>
                <div>Please Upload Answer for the question above</div>
                {/* <button className="sign-in-button-4">
                Upload Answer
              </button> */}
                <FileUpload
                  ImageUrl={AnswerPDF}
                  setImageUrl={setAnswerPDF}
                  ExamData={ExamData}
                  ResultData={ResultData}
                />

              </div>
              :
              <div>
                {ResultData.meta.return_pdf == "" ?
                  <div style={{ margin: "10px 0" }}>
                    <div>If you want to change the answer please upload the new PDF</div>
                    <FileUpload
                      ImageUrl={AnswerPDF}
                      setImageUrl={setAnswerPDF}
                      ResultData={ResultData}
                      ExamData={ExamData}
                    />
                  </div>
                  :
                  <div>
                  </div>
                }
              </div>
            }
            <div>
              <button className="sign-in-button-4"
                onClick={() => {
                  setShowAnswer(true)
                }}
              >
                View Uploaded Answer
              </button>
            </div>
            <div>
              {ResultData.meta.return_pdf !== "" &&
                <div>

                  <button className="sign-in-button-4"
                    onClick={() => {
                      setShowReturnAnswer(true)
                    }}
                  >
                    View Return Answer
                  </button>
                </div>
              }
            </div>
            {/* <img src={ExamData.meta.image} style={{width:"100%"}} />
            <embed src={ExamData.meta.pdf} style={{width:"100%",height:"100vh"}}/> */}
          </div>
        </div>
      </div>
      {ShowQuestion &&
        <div className='modal'
          onClick={() => { setShowQuestion(false) }}
        >
          <div onClick={() => { }}>
            <embed src={ExamData.meta.pdf} style={{ width: "100%", height: "100vh" }}></embed>
          </div>
        </div>
      }
      {ShowAnswer &&
        <div className='modal'
          onClick={() => { setShowAnswer(false) }}
        >
          <div onClick={() => { }}>
            <embed src={ResultData.meta.submitted_pdf} style={{ width: "100%", height: "100vh" }}></embed>
          </div>
        </div>
      }
       {ShowReturnAnswer &&
        <div className='modal'
          onClick={() => { setShowReturnAnswer(false) }}
        >
          <div onClick={() => { }}>
            <embed src={ResultData.meta.return_pdf} style={{ width: "100%", height: "100vh" }}></embed>
          </div>
        </div>
      }
    </div>
  )
}